import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { addPhaseAboveInProjectTemplate } from '../../actions';
import { createProjectTemplateProjectPhase } from '../../slices';
import { InsertDirection } from '../../types';
function* AddPhaseAboveInProjectTemplateSaga(action) {
    try {
        const { payload: { projectPhaseId } } = action;
        const newProjectPhase = {
            projectPhaseId: floatUid(),
            isNew: true,
            entityOrder: []
        };
        yield put(createProjectTemplateProjectPhase({
            projectPhase: newProjectPhase,
            insertAt: {
                id: projectPhaseId,
                direction: InsertDirection.Above
            }
        }));
    } catch (error) {
        logger.error('Error in add a new phase above', {
            error
        });
        message.error('There was an error while adding a new phase above');
    }
}
export function* watchAddPhaseAboveInProjectTemplateSaga() {
    yield takeLatest(addPhaseAboveInProjectTemplate.type, AddPhaseAboveInProjectTemplateSaga);
}
